<template>
  <div ref="whole_page" id="DigiMenuPage">

    <vs-alert class="mb-5 signature-required-alert"  icon-pack="feather" color="warning" icon="icon-alert-circle" v-if="!hasSignature">
        Please ensure you have a signature to avoid hidden modules.
    </vs-alert>

    <div>
      <div class="limit-width_fixed-scalable" style="text-align: left;">
          <div class="w-full">
            <ul>
              <div style="min-width: 180px; max-width: 645px">
                <li style="height: 49px;" >
                  <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                          <span><feather-icon class="pt-1" icon="FileTextIcon" svg-classes="stroke-current"></feather-icon></span>
                        </div>
                      </template>

                      <vs-button
                        size="large"
                        class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                        style="border-radius:0 7px 7px 0"
                        @click="openProgressPopup">
                        View Your Progress
                      </vs-button>
                    </vx-input-group>
                  </vx-card>
                </li>
              </div>
            </ul>
          </div>
        </div>

        <!-- <div class="limit-width_fixed-scalable mt-5" style="text-align: left;">
          <div class="w-full">
            <ul>
              <div style="min-width: 180px; max-width: 645px">
                <li style="height: 49px;" >
                  <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                          <span><feather-icon class="pt-1" icon="ShoppingBagIcon" svg-classes="stroke-current"></feather-icon></span>
                        </div>
                      </template>

                      <vs-button
                        size="large"
                        class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                        style="border-radius:0 7px 7px 0"
                        @click="gotoPublicPortal">
                        Buy More Courses
                      </vs-button> 
                    </vx-input-group>
                  </vx-card>
                </li>
              </div>
            </ul>
          </div>
        </div>-->
      <vs-divider position="center" class="mt-5"></vs-divider>
    </div>

    <vs-popup title="Module Progress" :active.sync="isModuleProgressStatusPopupActive">
      <student-module-progress
        id="module-progress-component"
        @closeModuleProgressCallBack="isModuleProgressStatusPopupActive = false"
        :progressPopupData="progressPopupData"
        :allModules="allModules"
        :continueMilestones="continueMilestones"
        :currentStudentId="currentStudentId"
        :logbooksForModules="logbooksForModules"
        :courseProgressStucture="courseProgressStucture"
        :isActive="isModuleProgressStatusPopupActive"
      />
    </vs-popup>
    
    <select-module-view 
      :isViewActive="isSelectModuleViewActive"
      :allModules="allModules"
      @startNew="startNew"
      @continueModuleSelected="continueModuleSelected"
      :moduleDataLoadComplete ="moduleDataLoadComplete"
    />

    <module-continue-view
      :isViewActive="isModuleContinueViewActive"
      :continueMilestones="continueMilestones"
      @continueFrom="continueFrom"
      :selectedModule="selectedModule"
      @backToSelectModule="backToSelectModule"
    />

    <mentor-modules-view
      :isViewActive="isMentorModulesViewActive"
      @backToMenu="backToMenu"
      @showLoadingOnElement="showLoadingOnElement"
      :availableModules="availableModules"
      @stopLoadingOnElement="stopLoadingOnElement"
      @moduleSelected="moduleSelected"
    />

    <div class="vx-row mx-auto">

      <div v-if="isProfileSectionViewActive" class="mobileview">

        <div class="mt-4 w-full">
          <ul style="margin-top: 3px;flex-wrap: wrap;">
            <div class="limit-width_fixed-scalable" style="text-align: left;">
              <li>
                  <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 90vw">
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text glow-effect_bg-color__blend bg-color">
                          <span><feather-icon class="pt-1" icon="SmartphoneIcon" svg-classes="stroke-current"></feather-icon></span>
                        </div>
                      </template>

                      <vs-button
                        :disabled="true"
                        size="large"
                        class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-item text__school-tertiary-color bg-color"
                        type="filled"
                        color="">
                        Mentoring and Backpack
                      </vs-button>
                    </vx-input-group>
                  </vx-card>
              </li>
                <div class="w-full">
                  <ul>
                    <div style="min-width: 180px; max-width: 645px">
                      <li v-if="$isMentoringAvailable()" style="height: 49px;" class="mb-4 mt-6">
                        <vx-card id="mentoring-btn_menu" class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
                          <vx-input-group>
                            <template slot="prepend">
                              <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                                <span><feather-icon class="pt-1" icon="UserIcon" svg-classes="stroke-current"></feather-icon></span>
                              </div>
                            </template>

                            <vs-button
                              size="large"
                              class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                              style="border-radius:0 7px 7px 0"
                              @click="goToMentoring">
                              Mentoring
                            </vs-button>
                          </vx-input-group>
                        </vx-card>
                      </li>
                      <li style="height: 49px;" class="mb-16">
                        <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
                          <vx-input-group>
                            <template slot="prepend">
                              <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                                <span><feather-icon class="pt-1" icon="ShoppingBagIcon" svg-classes="stroke-current"></feather-icon></span>
                              </div>
                            </template>

                            <vs-button
                              size="large"
                              class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                              style="border-radius:0 7px 7px 0"
                              @click="openBackpack">
                              Backpack
                            </vs-button>
                          </vx-input-group>
                        </vx-card>
                      </li>
                    </div>
                  </ul>
                </div>
            </div>
          </ul>
        </div>

      </div>
    </div>
  
  </div>

</template>

<script>
import ProfileSectionView from './menucomponents/ProfileSectionView.vue';
import SelectModuleView from './menucomponents/SelectModuleView.vue';
import ModuleContinueView from './menucomponents/ModuleContinueView.vue';
import MentorModulesView from './menucomponents/MentorModulesView.vue';
import StudentModuleProgress from './menucomponents/StudentModuleProgress.vue'

export default {
  components: {
    ProfileSectionView,
    SelectModuleView,
    ModuleContinueView,
    MentorModulesView,
    StudentModuleProgress,
  },
  data() {
    return {
      isProfileSectionViewActive: true,
      isSelectModuleViewActive: true,
      isModuleContinueViewActive: false,
      isMentorModulesViewActive: false,
      isModuleProgressStatusPopupActive: false,
      currentStudentId: 0,
      data: [],
      newModules: [],
      continueModules: [],
      continueMilestones: [],
      coins: 0,
      selectedModule: {},
      selectedMentorModule: {},
      availableModules: [],
      modulesForBackpack: [],
      allModules: [],
      isMentoringAvailable: false,
      hasSignature: true,
      moduleDataLoadComplete: false,
      progressPopupData: [],
      taskList:[],
      logbooksForModules:[],
      courseProgressStucture:[],
    };
  },
  computed: {

  },
  methods: {
    loadMenuData(studentId) {
      var self = this;

      var onSuccess = function (response) {
        self.data = response.data;
        self.allModules = self.data;
        self.moduleDataLoadComplete = true;
        self.availableModules = self.data.map(x => x.moduleId);
        self.continueMilestones = self.data.filter(function(item) { return item.isMilestone }).sort((a, b) => Date.parse(a.sortDate) < Date.parse(b.sortDate) ? 1 : -1);
        self.modulesForBackpack = JSON.stringify(self.data.map((item) => {return {label: item.moduleName, value: item.moduleId} }));

        localStorage.setItem("StudentModules", self.modulesForBackpack);

        self.$emit("data_load_done");
      };
      var onFinally = function () {
        self.checkIfTimeCapturingRequired();
        self.doesStudentHaveSignature();
      };

      self.$ajaxGet(self, "Student/LoadMenu?studentId=" + studentId, onSuccess, onFinally);
    },
    goToMentoring() {
      this.isProfileSectionViewActive = false;
      this.isSelectModuleViewActive = false;
      this.isModuleContinueViewActive = false;
      this.isMentorModulesViewActive = true;
    },
    viewProfile() {
      let routeData = this.$router.resolve({ name: 'StudentProfile' });
      window.open(routeData.href, '_blank');
    },
    startNew(moduleId, taskDisplayId, isLearningStyleB) {
      var self = this;
      if(moduleId && taskDisplayId){
        if(isLearningStyleB){
            self.$router.push({ name: 'LearningStyleBViewer', params: { moduleId: moduleId }});
        }
        else{
            localStorage.setItem("currentModule", moduleId);
            self.$router.push({ name: 'StoryViewer', params: { mode: "story", taskDisplayId: taskDisplayId, moduleId: moduleId, isStudent: "true", coins: self.coins } });            
        };
      }
    },
    continueModuleSelected(module) {
      var self = this;
      self.isProfileSectionViewActive = false;
      self.isSelectModuleViewActive = false;
      self.selectedModule = module;

      var moduleMilestones = self.continueMilestones.filter(x => x.moduleId == self.selectedModule.moduleId);
      if(self.selectedModule.isLearningStyleB){
        self.$router.push({ name: 'LearningStyleBViewer', params: { moduleId: self.selectedModule.moduleId }});
      }
      else{
        if(moduleMilestones.length == 0){
          self.continueFrom(self.selectedModule.moduleId, self.selectedModule.taskDisplayId)
        }
        else{
          self.isModuleContinueViewActive = true;
        }
      }
    },
    continueFrom(moduleId, taskDisplayId) {
      var self = this;
      
      if(moduleId && taskDisplayId){
        self.showLoadingOnElement('whole_page', 1, 'material');
        self.getCoins(moduleId, function() {
          localStorage.setItem("currentModule", moduleId);
          // taskDisplayId = "N-1"
          self.$router.push({ name: 'StoryViewer', params: { mode: "story", taskDisplayId: taskDisplayId, moduleId: moduleId, isStudent: "true", coins: self.coins } });
        })
      }
    },
    getCoins(moduleId, whenDone) {
      var self = this;

      var onSuccess = function (response) {
        self.coins = response.data;
        if (whenDone && typeof whenDone == "function")
          whenDone();
      };

      self.$ajaxGet(self, "CoinTransaction/GetCoins?studentId=" + self.currentStudentId + "&moduleId=" + moduleId, onSuccess);
    },
    getCurrentUserId(whenDone) {

      var userIdFromLocalStorage = localStorage.getItem("Current_User_Id");

      if (userIdFromLocalStorage != undefined && userIdFromLocalStorage != null && userIdFromLocalStorage != "") {
        if (whenDone && typeof whenDone == "function") {
          whenDone();
          return;
        }
      }

      var self = this;
      var onSuccess = response => {
        localStorage.setItem("Current_User_Id", response.data);
        if (whenDone && typeof whenDone == "function")
          whenDone();
      };
      self.$ajaxGet(self, "user/GetUserId", onSuccess);
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    stopLoadingOnElement(element) {
      var self = this;
      self.$vs.loading.close(self.$refs[element].$el);
    },
    moduleSelected(mod) {
      this.isMentorModulesViewActive = false;
      this.$router.push({ name: "Mentoring", query: { module: mod.moduleId, n: mod.moduleName } });
    },
    backToSelectModule() {
      this.isProfileSectionViewActive = true;
      this.isSelectModuleViewActive = true;
      this.selectedModule = {};
      this.isModuleContinueViewActive = false;
    },
    backToMenu() {
      this.isProfileSectionViewActive = true;
      this.isSelectModuleViewActive = true;
      this.selectedModule = {};
      this.isModuleContinueViewActive = false;
      this.isMentorModulesViewActive = false;
      this.isMentoringMenuViewActive = false;
    },
    openBackpack(){
      this.$router.push({ name: 'BackpackViewer' });
    },
    isMentoringAvailableFunction(){
      var self = this;
      var onSuccess = response => {
        self.isMentoringAvailable = response.data;
      };
      self.$ajaxGet(self, "Site/IsMentoringAvailable", onSuccess);
    },
    checkIfTimeCapturingRequired() {
      var self = this;
      var onSuccess = response => {
        if (response.data && response.data != 0) {
          self.stopLoadingOnElement('whole_page');
          setTimeout(() => {
            if (response.data == 1) {
              self.$router.push({ name: 'TimeCapture' });
            } else if (response.data == 2) {
              self.$router.push({ name: 'PracticalTimeCapture' });
            }
          }, 100);
        } else {
          self.isMentoringAvailableFunction();

          if (self.$getSiteId() == 26) {
            self.checkIfItsTimeToDoSarsWeeklySubmission();
            self.$vs.loading.close(self.$refs.whole_page.$el);
          } else {
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
        }
      };
      self.$ajaxGet(self, "Student/CheckTimeCapture", onSuccess);
    },
    checkIfItsTimeToDoSarsWeeklySubmission() {
      var self = this;

      var onSuccess = response =>{
        if (!self.$isEmpty(response.data)) {
          self.$router.push({ name: 'SARSTimeCapture', query: { moduleId: response.data } });
        }
      }
    
      var onFinally = response =>{
        self.$vs.loading.close(self.$refs.whole_page.$el);
      }
    
      self.$ajaxGet(self, "SonkeSarsQuestion/CheckIfItsTimeToDoSarsWeeklySubmission", onSuccess, onFinally);
    },
    doesStudentHaveSignature(){
      var self =this;
      var onSuccess = response => {
        self.hasSignature = response.data;
      };
      self.$ajaxGet(self, "Student/Signature", onSuccess);
    },
    getCurrentUserId() {
      var self = this;
      self.currentStudentId = localStorage.getItem('Current_User_Id');
      self.loadMenuData(self.currentStudentId);
    },
    openProgressPopup(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");
      var onSuccess = response =>{
        self.progressPopupData = response.data;
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
        self.isModuleProgressStatusPopupActive = true;
      }
    
      self.$ajaxGet(self, "Course/GetCourseProgressOverview" , onSuccess, onFinally);
    },
    getActionableTasks(){
      var self = this;

      var onSuccess = response =>{
        self.courseProgressStucture = response.data;
        self.isModuleProgressStatusPopupActive = true;
      }

      var onFinally = response => {
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }

      if(self.progressPopupData){
        var sendData = self.progressPopupData.filter(x=>x.actionNeeded);
        if(sendData){
          self.$ajaxPost(self, "Course/getActionableTasks" ,sendData , onSuccess, onFinally);
        }
      }
    },
    gotoPublicPortal(){
      if(window.location.href.toUpperCase().includes('DIGICAMPUS')){
        window.location =("/home");
      }
    },
  },
  mounted() {
    var self = this;
    self.showLoadingOnElement('whole_page', 1, 'material');
    self.getCurrentUserId();
  }
};
</script>

<style lang="scss">
  @import "@/digicampus/assets/main-digi.scss";

  #DigiMenuPage{
    .signature-required-alert{
      height: unset !important;
    }
  }
  .table_float_direction_progressDataList{
    text-align: center;
  }
  @media screen and (max-width:400px){
      .table_float_direction_progressDataList{
      text-align: left;
    }
  }
  
  #module-progress-component{
    .module-item{
      &:hover {
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.3);
        transform: scale(1.02);
      }
      text-align: center !important;
    }
    .progress-data{
      .vx-card__body{
        padding: 1rem 1.5rem !important; 
      }
      .card_small{
        .vx-card__body{
          padding: 0rem 0.5rem !important; 
        }
      }
    }
    
    .vs-collapse{
      padding: 0 !important;
      cursor: unset;
    }
    .vs-collapse-item--header{
      cursor: pointer;
    }
    .open-item{
      .vs-collapse-item--content{
        max-height: fit-content !important;
      }
      .con-content--item{
        padding: 0 !important;
      }
    }
    .action-task{
      z-index: 200;
      cursor: pointer;
    }
  }

  @media screen and (max-width:400px){
    #module-progress-component{
      .module-item{
        box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.3);
      }
      .progress-data{
        .card_small{
          .vx-card__body{
            padding: 0rem 0.5rem !important; 
          }
        }
        
      }
      .vs-collapse{
        padding: 0 !important;
      }
    }
  }
</style>
